import { Currency } from "@types";

/**
 * Currencies where the deposit form shows a Pay Account selector for
 * fundingProfileRequired methods and sends fundingProfileId in the topup
 * request. Elsewhere the BE keeps auto-selecting the primary profile.
 */
export const PAY_ACCOUNT_SELECTION_CURRENCIES: Currency[] = [Currency.COP];
